import { ReactNode } from "react";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { UseControllerProps, useFormContext } from "react-hook-form";
import {
  Calendar,
  Home,
  IdCard,
  Mail,
  MapPin,
  Percent,
  Phone,
  User,
  Users,
} from "lucide-react";

interface InputProps extends UseControllerProps {
  children: ReactNode;
  name: string;
  label?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  min?: string;
  minLength?: number;
  maxLength?: number;
  max?: string;
  transform?: (value: string) => string;
  icon: string;
}

export default function InputForm({
  children,
  name,
  label,
  min,
  max,
  maxLength,
  minLength,
  type = "text",
  placeholder,
  transform,
  required = false,
  disabled = false,
  icon = "user",
}: InputProps) {
  const { register, formState, getFieldState, watch } = useFormContext();

  const { error } = getFieldState(name, formState);

  const valor = watch(name) || "";

  return (
    <div className="space-y-2">
      {label && (
        <Label
          htmlFor={name}
          className="flex items-center gap-2 text-[var(--color-z-blue)]"
        >
          {icon === "users" ? (
            <Users className="h-4 w-4 text-[#91bfe3]" />
          ) : icon === "idcard" ? (
            <IdCard className="h-4 w-4 text-[#91bfe3]" />
          ) : icon === "user" ? (
            <User className="h-4 w-4 text-[#91bfe3]" />
          ) : icon === "calendario" ? (
            <Calendar className="h-4 w-4 text-[#91bfe3]" />
          ) : icon === "email" ? (
            <Mail className="h-4 w-4 text-[#91bfe3]" />
          ) : icon === "fono" ? (
            <Phone className="h-4 w-4 text-[#91bfe3]" />
          ) : icon === "porcentaje" ? (
            <Percent className="h-4 w-4 text-[#91bfe3]" />
          ) : icon === "mapa" ? (
            <MapPin className="h-4 w-4 text-[#91bfe3]" />
          ) : icon === "home" ? (
            <Home className="h-4 w-4 text-[#91bfe3]" />
          ) : (
            <Users className="h-4 w-4 text-[#91bfe3]" />
          )}
          {children}
          {required && <span className="text-destructive">*</span>}
        </Label>
      )}

      <Input
        id={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        value={valor}
        minLength={minLength}
        maxLength={maxLength}
        min={min}
        max={max}
        {...register(name, {
          setValueAs: (v) => (transform ? transform(String(v)) : v),
        })}
        className={` pl-10  border-1 rounded-md px-3 text-base transition-colors ${
          error ? "border-destructive focus:border-destructive" : ""
        }`}
      />

      {error?.message && (
        <p className="text-sm text-destructive">{error.message}</p>
      )}
    </div>
  );
}
